import React from 'react';
import styled from 'styled-components';

import { baseColor, primaryHue3 } from 'modules/styles/colors';
import GradientView from 'components/UI/Banner/GradientView';

export interface PercentageBarProps {
  percentComplete: number;
}

export const Background = styled.div`
  background-color: ${baseColor};
  border-radius: 8px;
  height: 15px;
  width: 100%;
  margin: 10px 0px;
`;

const Bar = styled(GradientView)`
  background-color: ${primaryHue3};
  height: 15px;
  position: absolute;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-top-right-radius: ${props => (props.percentComplete > 95 ? '8px' : '0px')};
  border-bottom-right-radius: ${props => (props.percentComplete > 95 ? '8px' : '0px')};
  width: ${props => `${props.percentComplete}%` || '0%'};
`;

export default (props: PercentageBarProps) => (
  <Background>
    <Bar colors={[primaryHue3, '#17A2B8']} percentComplete={props.percentComplete} />
  </Background>
);
